import React, { useState } from 'react';
import {
  getInstitutionalTheme,
  institutionalTheme,
  resetInstitutionalTheme,
  saveInstitutionalTheme,
} from '../config/institutionalTheme';
import '../styles/Dashboard.css';

const colorFields = [
  ['primary', 'Color principal'],
  ['secondary', 'Color secundario'],
  ['text', 'Texto'],
  ['muted', 'Texto suave'],
  ['border', 'Bordes'],
  ['background', 'Fondo'],
  ['danger', 'Alertas'],
];

const InstitutionalSettingsPanel = () => {
  const [theme, setTheme] = useState(() => getInstitutionalTheme());
  const [statusMessage, setStatusMessage] = useState('');

  const updateField = (field, value) => {
    setTheme((current) => ({ ...current, [field]: value }));
  };

  const updateColor = (field, value) => {
    setTheme((current) => ({
      ...current,
      colors: {
        ...current.colors,
        [field]: value,
      },
    }));
  };

  const saveTheme = () => {
    const savedTheme = saveInstitutionalTheme(theme);
    setTheme(savedTheme);
    setStatusMessage('Marca institucional guardada y aplicada en este navegador.');
  };

  const restoreDefaults = () => {
    const defaultTheme = resetInstitutionalTheme();
    setTheme(defaultTheme);
    setStatusMessage('Marca institucional restaurada a la configuracion del despliegue.');
  };

  return (
    <section className="institutional-settings-panel">
      <div className="section-header">
        <div>
          <h2>Configuracion institucional</h2>
          <p>Logo, colores, nombre visible y pie de pagina del portal.</p>
        </div>
        <div className="admin-dashboard-actions">
          <button className="btn btn-secondary" type="button" onClick={restoreDefaults}>
            Restaurar
          </button>
          <button className="btn btn-primary" type="button" onClick={saveTheme}>
            Guardar marca
          </button>
        </div>
      </div>

      {statusMessage && <p className="clinical-files-message">{statusMessage}</p>}

      <div className="institutional-settings-grid">
        <div className="institutional-settings-form">
          <label>
            Nombre del aplicativo
            <input value={theme.applicationName || theme.institutionName} onChange={(event) => updateField('applicationName', event.target.value)} />
          </label>
          <label>
            Nombre de la institucion
            <input value={theme.institutionName} onChange={(event) => updateField('institutionName', event.target.value)} />
          </label>
          <label>
            Texto corto del logo
            <input value={theme.logoText} onChange={(event) => updateField('logoText', event.target.value)} placeholder="Ej. HCA" />
          </label>
          <label className="institutional-field-wide">
            URL del logo
            <input value={theme.logoUrl} onChange={(event) => updateField('logoUrl', event.target.value)} placeholder="/branding/logo.png o https://..." />
          </label>
          <label>
            Desarrollado por
            <input value={theme.developerName} onChange={(event) => updateField('developerName', event.target.value)} />
          </label>
          <label>
            URL desarrollador
            <input value={theme.developerUrl} onChange={(event) => updateField('developerUrl', event.target.value)} />
          </label>
          <label>
            Texto URL
            <input value={theme.developerDisplayUrl} onChange={(event) => updateField('developerDisplayUrl', event.target.value)} />
          </label>
        </div>

        <div className="institutional-color-grid">
          {colorFields.map(([field, label]) => (
            <label key={field}>
              {label}
              <span>
                <input type="color" value={theme.colors[field]} onChange={(event) => updateColor(field, event.target.value)} />
                <input value={theme.colors[field]} onChange={(event) => updateColor(field, event.target.value)} />
              </span>
            </label>
          ))}
        </div>

        <div className="institutional-preview">
          <span>Vista previa</span>
          <div className="institutional-preview-header" style={{ background: theme.colors.primary }}>
            {theme.logoUrl ? (
              <img src={theme.logoUrl} alt={theme.institutionName} />
            ) : (
              <strong>{theme.logoText || institutionalTheme.logoText}</strong>
            )}
            <p>{theme.applicationName || theme.institutionName}</p>
          </div>
          <button type="button" style={{ background: theme.colors.secondary }}>
            Accion principal
          </button>
          <small>
            Desarrollado por {theme.developerName} · {theme.developerDisplayUrl}
          </small>
        </div>
      </div>
    </section>
  );
};

export default InstitutionalSettingsPanel;
